import { ContractRole } from '@paid-ui/enums/contract';

export const isOwner = (role?: ContractRole | null) => {
  return (
    !!role && [ContractRole.PRINCIPAL, ContractRole.OFFEREE, ContractRole.OFFEROR].includes(role)
  );
};
